import React, { useState, useEffect,useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import SglContext from "../SglContext";

const page_url =
  "//" +
  window.location.host +
  "/" +
  window.location.pathname +
  window.location.search;

// sgl_show_id =
//   getQueryVariable("sid") && getQueryVariable("sid") != ""
//     ? getQueryVariable("sid")
//     : localStorage.getItem("show_id");

export default function RingDetail() {
  const Sgl = useContext(SglContext);
  const [class_groups, set_class_groups] = useState([]);
  const [show_date, set_show_date] = useState("");
  const [ring, set_ring] = useState({});
  const [show, set_show] = useState({});
  const [result_classes, set_result_classes] = useState([]);
  const [time_zone_date_time, set_time_zone_date_time] = useState({});
  const [default_tab, set_default_tab] = useState("entries");
  const [current_tab, set_current_tab] = useState("Entries");
  const [current_show, set_current_show] = useState(getQueryVariable("sid"));
  const [userData, set_userData] = useState({});
  const [loading, set_loading] = useState(true);

  const sgl_webservice_ring_detail = Sgl.nestApiUrl + "/ring/";
  const user_info_url = Sgl.nestApiUrl + "/users/getUser";

  // function constructor() {
  //   // ShowPickerElement = React.createRef();
  //   // bind function in constructor instead of render
  //   onShowChange = onShowChange.bind(this);
  //   openTab = openTab.bind(this);
  //   // openSection = openSection.bind(this);
  // }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  useEffect(() => {
    getUserData();
    axios
      .all([
        axios.get(sgl_webservice_ring_detail + getQueryVariable("ring_id"), {
          params: {
            show_date: getQueryVariable("s_date"),
            show_id: getQueryVariable("sid"),
          
            customer_id: Sgl.company_id,
          },
        })
      ])
      .then(
        axios.spread((res) => {
          set_show(res.data.show);
          set_ring(res.data.ring);
          set_show_date(res.data.show_date);
          set_class_groups(res.data.class_groups);
          set_result_classes(res.data.result_classes);
          set_time_zone_date_time(res.data.time_zone_date_time);
          set_loading(false);
          document.title =
          res.data.ring?.ring_name +
            " - Order of Go & Estimated Schedule (as of " +
            time_zone_date_time.time +
            ")";
          Sgl.reportToGA(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
              "/" +
              getQueryVariable("sid") +
              "/ring/detail/" +
              getQueryVariable("s_date") +
              "/ring/" +
              getQueryVariable("ring_id")
          );
          Sgl.reportToFB(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
              "/" +
              getQueryVariable("sid") +
              "/ring/detail/" +
              getQueryVariable("s_date") +
              "/ring/" +
              getQueryVariable("ring_id")
          );
          
        })
      );
  }, []);

  function getUserData() {
    axios.get(user_info_url).then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          set_userData(response.data.user);
        } else {
        }
      },
      (error) => {}
    );
  }

  function openTab(tabName) {
    return function (e) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(tabName).style.display = "block";
      e.currentTarget.className += " active";
      // current_tab = tabName;
      set_current_tab(tabName);
    };
  }

  function format_time(timeString) {
    if (timeString) {
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = H < 12 || H === 24 ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }
    return;
  }

  // function getDefaultTab(tab) {
  //   if (related_data.status == "Completed") {
  //     default_tab = "result";
  //     current_tab = "Results";
  //   } else if (class_details.order_of_go_set == 1) {
  //     default_tab = "order";
  //     current_tab = "Order";
  //   }
  //   if (default_tab == tab) {
  //     return " active";
  //   }
  //   return "";
  // }

  // function getDefaultDisplay(tab) {
  //   if (default_tab == tab) {
  //     return " display_block";
  //   }
  //   return " display_none";
  // }

  function onShowChange(show_id) {
    localStorage.setItem("show_id", show_id);
    window.location.href = page_url;
  }

  if (loading) {
    return null;
  }

  return (
    <div>
    <section className="search-area section-to-print">
      <h2 className="sgl-h2">
        {ring?.ring_name} - Order of Go & Estimated Schedule (as of{" "}
        {time_zone_date_time.time})
      </h2>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
      {class_groups.length > 0 ? (
        // { (2 > 0) ?
        <div className='details'>
          <div className='tab'>
            <button
              className={["tablinks", "active"].join(" ")}
              onClick={openTab("upcoming")}>
              Upcoming Classes
            </button>
            <button
              className={["tablinks"].join(" ")}
              onClick={openTab("recent")}>
              Recent Results
            </button>
          </div>

          <div
            id='upcoming'
            className={["tabcontent", "display_block"].join(" ")}>
            {class_groups.map((class_group, index) => {
              return (
                <div>
                  <div className='class-details, primary-header'>
                    <p className='ring-name'>
                      {class_group.group_name}{" "}
                      {class_group.sponsors != "" ? (
                        <b>
                          <br /> Sponsored By: {class_group.sponsors}
                        </b>
                      ) : (
                        ""
                      )}
                    </p>
                    {class_group.actual_start_time == "00:00:00" ? (
                      <p className='oog-status'>
                        Estimated Start:{" "}
                        {format_time(class_group.estimated_start_time)}
                      </p>
                    ) : (
                      <p className='oog-status'>
                        Started: {format_time(class_group.actual_start_time)}
                      </p>
                    )}
                  </div>
                  <div className='div-responsive'>
                    <table className='table table-striped'>
                      <thead>
                        <tr className='sgl-primary-header'>
                          <th>Order</th>
                          <th>Class</th>
                          <th>Entry</th>
                          <th>Horse</th>
                          <th>Rider</th>
                        </tr>
                      </thead>
                      <tbody>
                        {class_group.group_trips.map((data, index) => {
                          return (
                            <tr className='sgl-anchor'>
                              <td>
                                {data.order_of_go > 0
                                  ? data.order_of_go + "/"
                                  : "Unk/"}
                                {class_group.group_total_trips}
                              </td>
                              <td>{data.class_number}</td>
                              <td>{data.entry_number}</td>
                              <td>{data.entry_horse}</td>
                              <td>{data.rider_name}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>

          <div id='recent' className={["tabcontent"].join(" ")}>
            {result_classes.length > 0 ? (
              <div className='div-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr className='sgl-primary-header'>
                      <th>Recent</th>
                      <th>Results</th>
                    </tr>
                  </thead>

                  {result_classes.map((class_data, index) => {
                    return (
                      <tbody>
                        <tr>
                          <td>
                            <strong>{class_data.class_number}</strong>
                          </td>
                          <td>
                            <strong>{class_data.name}</strong>
                          </td>
                        </tr>
                        {class_data.entries.length > 0 ? (
                          class_data.entries.map((entry, index) => {
                            return (
                              <tr>
                                <td>{entry.placing}</td>
                                <td>{entry.horse}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td>Results</td>
                            <td>Not Available</td>
                          </tr>
                        )}
                      </tbody>
                    );
                  })}
                </table>
              </div>
            ) : (
              <div>No results available.</div>
            )}
          </div>
        </div>
      ) : (
        <div>There are no active trips in this ring at this time.</div>
      )}
      <div className='copyright-text'>
        {process.env.REACT_APP_COPYRIGHT_TEXT}
      </div>
    </section>
    </div>
  );
}
